import Bottleneck from "bottleneck";

export const taskManager = new Bottleneck({
  maxConcurrent: 4,
});
